import { merge, object_map, scan } from "@pdfking/rfunc"
import { IsArray, Keys } from "@pdfking/tfunc"
import create_app from "@pdfking/workflow/vue/3/create_app"
import append from "../dom/append"
import element from "../dom/element"
import toggle_class from "../dom/toggle_class"
import get_router from "../routes/router"

export default function init(
  cls: { props: Record<string, unknown> | string[] },
  el: {
    name?: string
    value?: string
  } & (HTMLElement | HTMLInputElement | null),
  data: null | Record<string, unknown>
) {
  const mounted = create_app({
    app: cls,
    el: element("div"),
    props: merge(
      el
        ? object_map(
            (k: string) => k,
            (k: string) => el.getAttribute(`data-${k}`) || null,
            IsArray(cls.props) ? cls.props : Keys(cls.props)
          )
        : {},
      el
        ? {
            content: el.innerHTML,
            disabled: !!el.hasAttribute("disabled"),
            name: el.name,
            placeholder: el.getAttribute("placeholder") || undefined,
            value: el.value,
          }
        : {},
      data || {}
    ),
    router: get_router(),
  })

  if (el) {
    scan(
      (attr: string) => {
        const value = el.getAttribute(attr)
        if (value) mounted.$el.setAttribute(attr, value)
      },
      ["id", "style"]
    )

    if (data?.preserve_class) {
      toggle_class(
        mounted.$el,
        object_map(
          (_e: string) => _e,
          (_e: string) => true,
          el.classList
        ) as Record<string, boolean>
      )
    }

    el.replaceWith(mounted.$el)
  } else {
    append(document.body, mounted.$el)
  }
  return mounted
}
